<template>
  <button class="button-grouped"
          :class="[theme,size]"
          @click.prevent="$emit('click')">
    <span class="left" :class="{'no-border':!$slots.right}">
      <slot name="left"/>
    </span>
    <span class="right" v-if="$slots.right">
      <slot name="right"/>
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonGrouped",
  props: {
    theme: {
      type: String,
      default: 'default',
      validator: (val) => ['default', 'white'].includes(val)
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['sm', 'md'].includes(val)
    },
  }
}
</script>

<style scoped lang="scss">
.button-grouped {
  @apply text-center rounded flex items-center text-white border border-transparent
  transition duration-200 outline-none cursor-pointer overflow-hidden;

  .left,
  .right {
    @apply flex items-center h-full transition duration-200;
  }

  .left {
    @apply border-r;

    &.no-border {
      @apply border-none;
    }
  }

  .right {
    @apply border-l transition duration-200;
  }

  &.md {
    @apply h-16 text-md;

    .left {
      padding: 0 22.5px;
    }

    .right {
      padding: 0 18px;
    }
  }

  &.sm {
    @apply h-14-2 text-2sm;

    .left {
      padding: 0 15px;
    }

    .right {
      padding: 0 15px;
    }
  }

  &.default {
    @apply bg-gray shadow-gray;
    .left {
      @apply border-gray-darken;
    }

    .right {
      @apply border-gray text-icon bg-gray-darken;
    }

    &:hover,
    &:focus {
      .right {
        @apply bg-gray text-white;
      }
    }

    &:disabled {
      @apply bg-gray-light;
    }
  }

  &.white {
    @apply border border-border text-text-label bg-white;
    .left {
      @apply border-border;
    }

    .right {
      @apply border-white text-icon;
    }

    &:hover,
    &:focus {
      @apply border-border-hover;
      .left {
        @apply border-border-hover;
      }

      .right {
        @apply text-text-label;
      }
    }

    &:disabled {
      @apply border-border text-icon cursor-not-allowed;
    }
  }
}
</style>